module.exports = __webpack_public_path__ + "img/meghpakhi.166bbf5a.jpg";